<template>
  <div class="container d-flex">
    <VCheckbox
      :label="$t('forms.labels.notifyEmail')"
      :disabled="isCheckboxDisabled(user.email)"
      :value="hasEmailMode"
      @input="(val)=>onChecboxChange(val,'email')"
    />
    <VCheckbox
      :label="$t('forms.labels.notifySms')"
      :disabled="isCheckboxDisabled(user.sms)"
      :value="hasSmsMode"
      @input="(val)=>onChecboxChange(val,'sms')"
    />
    <VCheckbox
      :label="$t('forms.labels.notifyApp')"
      :disabled="isCheckboxDisabled(user.app)"
      :value="hasAppMode"
      @input="(val)=>onChecboxChange(val,'app')"
    />
  </div>
</template>
<script>
import VCheckbox from '../shared/widgets/forms/VuetifyInputs/VCheckbox.vue';

export default {
    components: {
        VCheckbox,
    },
    props: {
        user: {
            type: Object,
            default: () => {},
        },
        alertId: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasEmailMode() {
            return this.user.email;
        },
        hasSmsMode() {
            return this.user.sms;
        },
        hasAppMode() {
            return this.user.app;
        },
    },
    methods: {
        isCheckboxDisabled(fieldVal) {
            return this.isLoading || fieldVal === null;
        },
        onChecboxChange(checkboxVal, mode) {
            const emitPayload = {
                sms: this.hasSmsMode,
                email: this.hasEmailMode,
                app: this.hasAppMode,
            };
            emitPayload[mode] = checkboxVal;
            this.$emit('onSelectionChange', { updatedData: emitPayload, alertId: this.alertId });
        },
    },
};
</script>
<style scoped>
</style>
